import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { BaseComponent } from '../BaseComponent';
import { Offer } from '../../model/Offer';
import { AbstractControl, FormGroup } from '@angular/forms';
import { CalculationResponseResultPremiumDto } from '../../model/business/calculation/CalculationResponseResultPremiumDto';
import { TranslateService } from '@ngx-translate/core';
import { SessionService } from '../../session-service.service';
import { FontTypeEnum } from 'src/app/model/enums/FontTypeEnum';
import { InsurerEnum } from 'src/app/model/enums/InsurerEnum';
import { BaseOption } from '../../model/BaseOption';
import { AvailablePremiumsPipe } from '../../available-premiums.pipe';

@Component({
  selector: 'app-premiums-overview',
  templateUrl: './premiums-overview.component.html',
  styleUrls: ['./premiums-overview.component.css']
})
export class PremiumsOverviewComponent extends BaseComponent implements OnInit, OnChanges {
  @Input()
  optionsList: Offer[];

  @Input()
  value: InsurerEnum;

  @Input()
  isDisabled = false;

  @Input()
  fontFamily: any;

  @Input()
  textColor: any;

  @Input()
  inputBorderColor: string;

  @Input()
  inputColor: string;

  @Input()
  formGroup: FormGroup;

  @Output()
  selectPremiumHandler = new EventEmitter<CalculationResponseResultPremiumDto>();

  controlType = this.constructor.name;
  FontTypeEnum = FontTypeEnum;
  InsurerEnum = InsurerEnum;
  offersList: BaseOption[] = [];

  constructor(translateService: TranslateService,
              sessionService: SessionService,
              private availablePremiumsPipe: AvailablePremiumsPipe) {
    super(translateService, sessionService);
  }

  ngOnInit(): void {
    if (this.value !== undefined) {
      this.control.setValue(this.value);
    }
    const validator = this.control.validator
      ? this.control.validator({} as AbstractControl)
      : {};
    this.isRequired = validator?.required;
    super.ngOnInit();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.value) {
      this.value = changes.value.currentValue;
      this.offersList = [];
      const filteredList = this.availablePremiumsPipe.transform(this.optionsList, this.value);
      filteredList.forEach(item => {
        this.offersList.push({
          text: item.insurerName,
          value: item.premium,
        });
      });
    }
  }

  selectPremium(event: BaseOption): void {
    const chosenInsurer = this.optionsList.filter(option => option.insurerName === event.text)[0];

    if (!chosenInsurer) {
      throw new Error(`Cannot find insurer with name ${event.text}`);
    }

    this.selectPremiumHandler.emit(chosenInsurer);
  }

}
